import { Spin, Icon } from "antd";
import React from "react"
import {ReactComponent as customSpinner} from "../../Images/new_spin.svg"

export const CustomSpinner = <Spin indicator={<Icon component={customSpinner} style={{ width:'100%', fontSize: 56 }} spin />} />;